import React from 'react';
import { SvgIcon } from '@material-ui/core';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';
import { SubscriptionOutline as SubscriptionOutlineIcon } from '../components/Icons';
import { moduleEnableSubscription } from '../module-params';

const appBarItemsList = [
  {
    name: 'My Account',
    href: '/account-settings',
    icon: <AccountCircleOutlinedIcon />,
  },
  moduleEnableSubscription
    ? {
        name: 'Billing',
        href: '/billing',
        icon: <ReceiptOutlinedIcon />,
      }
    : null,
  moduleEnableSubscription
    ? {
        name: 'Subscriptions',
        href: '/subscriptions',
        icon: (
          <SvgIcon
            component={SubscriptionOutlineIcon}
            className="subscription-icon"
          />
        ),
      }
    : null,
  {
    name: 'Alerts',
    href: '/alerts',
    icon: <NotificationsActiveOutlinedIcon />,
  },
  {
    name: 'Reports',
    href: '/reports',
    icon: <BarChartOutlinedIcon />,
  },
];

export default appBarItemsList.filter((n) => n);
